import React from 'react'
import MaxAlert from '@berlitz/alert'
import Button from '@berlitz/button'
import { ContentWrapper, ButtonWrapper, StickyAlertWrapper } from '../style'
import RichText from '@berlitz/globals/lib/components/RichText'

const AlertCookies = ({
  bannerText,
  buttonText,
  handleTermsAcceptClick,
  isActive,
  index,
}) => {
  const buttonInline = bannerText?.length < 250

  return (
    <StickyAlertWrapper fixed isActive={isActive} index={index}>
      <MaxAlert rounded>
        <ContentWrapper data-key="max-alert_banner" buttonInline={buttonInline}>
          <RichText dangerouslySetInnerHTML={{ __html: bannerText }} />
          <ButtonWrapper buttonInline={buttonInline}>
            <Button buttonType="info" onClick={handleTermsAcceptClick} small>
              {buttonText}
            </Button>
          </ButtonWrapper>
        </ContentWrapper>
      </MaxAlert>
    </StickyAlertWrapper>
  )
}

export default AlertCookies
